import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DocumentProcessStatusCode, DOCUMENT_PROCESS_STATUS_LABEL_KEYS } from '@dwo/enums';
import { DocumentStatusDialogData } from './document-status-dialog';

@Component({
  selector: 'app-document-status-dialog',
  templateUrl: './document-status-dialog.component.html',
  styleUrls: ['./document-status-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DocumentStatusDialogComponent {
  // Options come from the backend catalog (project-scoped); labelKey is an optional parenthetical
  // translation only for the codes we know about. Status 5 (For Info) is MIPS-only and never selectable here.
  readonly options: { id: number; no?: string; name: string; labelKey?: string }[];

  selectedStatusId: number | null;

  constructor(
    public dialogRef: MatDialogRef<DocumentStatusDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public model: DocumentStatusDialogData,
  ) {
    this.options = (model.statuses ?? [])
      .filter((status) => status.id !== DocumentProcessStatusCode.ForInfo)
      .map((status) => ({
        id: status.id,
        no: status.no,
        name: status.name,
        labelKey: DOCUMENT_PROCESS_STATUS_LABEL_KEYS[status.id],
      }));
    this.selectedStatusId = this.options.some((o) => o.id === model.currentStatusId) ? model.currentStatusId : null;
  }

  confirm(): void {
    this.dialogRef.close(this.selectedStatusId);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
